export default "__VITE_ASSET__4d5e2c42__"